export default "__VITE_ASSET__3RtS2tmh__"